export const NOTES_MAX_LENGTH = 1000;
